import type { Contact } from '../types/api/Contact/Contact';
import type { YupSchemaNullableReferenceType } from '../utils/yupHelpers';

export interface ContactData {
  id: string | null;
  option: { value: string; label: string } | null;
  isNewContact: boolean;
  contact?: Omit<Contact, 'id' | 'isArchived' | 'company'> & {
    company: YupSchemaNullableReferenceType;
  };
}

interface UseContactCreationProps {
  onCreateNew: (contact: ContactData) => void;
  onCancelNew: () => void;
  company: YupSchemaNullableReferenceType;
}

export const useContactCreation = ({
  onCreateNew,
  onCancelNew,
  company,
}: UseContactCreationProps): {
  createNewContact: () => void;
  cancelNewContact: () => void;
} => {
  const createNewContact = (): void => {
    const newContact: ContactData = {
      id: null,
      option: null,
      isNewContact: true,
      contact: {
        firstName: '',
        lastName: '',
        emailAddress: '',
        phoneNumber: '',
        jobTitle: '',
        notes: null,
        company,
        fullName: () => '',
      },
    };
    onCreateNew(newContact);
  };

  return {
    createNewContact,
    cancelNewContact: onCancelNew,
  };
};
